import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import * as RequestActions from '../../../actions/requestActions';
import ImageLeft from '../../custom/sections/ImageLeft';
//import SelectableImageRight from '../../custom/sections/SelectableImageRight';
import WebApiContent from '../../../constatns/web-api';
import CardSection from '../../custom/sections/CardSection';
import './index.css';


class WebApi extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }


  render() {
    const { lang } = this.props;

    return (
      <div className='page-padding'>
        <ImageLeft lang={lang} content={WebApiContent.leftImage}/>
        <CardSection lang={lang} content={WebApiContent.cardSection}/>
        {/* <SelectableImageRight lang={lang} content={WebApiContent.selectableImage}/> */}
      </div>
    );
  }
}


const mapStateToProps = state => ({
  lang: state.request.lang
});


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    ...RequestActions,
  }, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(WebApi);
